define('bindingHandlers/popover',[
    'lib/lodash4',
    'jquery',
    'lib/knockout',

    //no reference
    'lib/bootstrap.tooltip',
    'lib/bootstrap.popover',
    'extensions/i18n/knockout.i18n',
    'bindingHandlers/include'

], function (
    _,
    $,
    ko
    ) {
    "use strict";

    var IS_OPEN = 'isOpen',
        UPDATE_POSITION = 'updatePosition';

    var TITLE_TEMPLATE_NAME   = "templates/widgets/popoverTitle";
    var CONTENT_TEMPLATE_NAME = "templates/widgets/popoverContents";

    var POPOVER_TITLE_CLASS = 'popover-title-contents';
    var POPOVER_CONTENT_CLASS = 'innerPopover';
    var POPOVER_CLICK_OFF_EVENT = 'clickOffEvent';

    function getPopover($popoverTrigger, settings){
        // if the container option is used, find the popover using that element
        if (settings && settings.container) {
            return $(settings.container).find(".popover");
        }

        return $popoverTrigger.next().filter(".popover");
    }

    function closePopover($popoverTrigger, settings) {
        var keepInDom = settings ? settings.keepPopoverInDom : false;
        var $popoverContainer = getPopover($popoverTrigger, settings);
        var updateSettings = _.has( settings, IS_OPEN);

        if ( !keepInDom ){
            $popoverTrigger.popover('hide');
        } else {
            $popoverContainer.css('visibility', 'hidden');
        }

        if ( updateSettings ){
            settings.isOpen(false);
        }

        if (settings.clickOffToClose) {
            document.removeEventListener('click', getOnClickOffEvent($popoverTrigger), false);
        }

        triggerOnPopoverHidden(settings);
    }

    function getOnClickOffEvent($popoverTrigger) {
        if ($popoverTrigger.length) {
            return ko.utils.domData.get($popoverTrigger[0], POPOVER_CLICK_OFF_EVENT);
        }
    }

    function triggerOnPopoverHidden(settings) {
        if(settings.data && _.isFunction(settings.data.onPopoverHidden)) {
            settings.data.onPopoverHidden();
        }
    }

    function getCloseHandler( $popoverTrigger, settings){
        return function(event){
            event.preventDefault();
            closePopover($popoverTrigger, settings);
        };
    }

    function removeControlListeners ( $popoverTrigger, settings ){
        var $popoverContainer = getPopover($popoverTrigger, settings);

        $popoverContainer.find('.btn-close').off('click.popoverClose');
        $popoverContainer.find('.popover-apply-btn').off('click.popoverApply');

        if (settings.clickOffToClose) {
            document.removeEventListener('click', getOnClickOffEvent($popoverTrigger), false);
        }
    }

    function addControlListeners ( $popoverTrigger, settings){
        var $popoverContainer = getPopover($popoverTrigger, settings),
            closeHandler = getCloseHandler($popoverTrigger, settings);

        removeControlListeners($popoverTrigger, settings);

        $popoverContainer.find('.btn-close').on('click.popoverClose',         closeHandler);
        $popoverContainer.find('.popover-apply-btn').on('click.popoverApply', closeHandler);

        if (settings.clickOffToClose) {
            document.addEventListener('click', getOnClickOffEvent($popoverTrigger), false);
        }

    }

    /**
     * Uses the popover triggering element to find the popover and repositions the popover based on the size of the triggering
     * element and the popover.
     *
     * @param $element - the triggering element that caused the popover to be shown
     * @param $popover - the popover element
     * @param placement - top, left, right, or bottom - location of the popover relative to the triggering element
     */
    function repositionPopup( $element, $popover, placement ){
        var popoverData = $popover ? $popover.position() : null,
            elementData = $element ? $element.position() : null,
            TOP = 'top', BOTTOM = 'bottom', LEFT = 'left';

        function getPositionData( elementData, popupData ){
            switch(placement){
                case TOP:
                    return { top: elementData.top - popupData.height, left: elementData.left + elementData.width/2 - popupData.width/2 };
                case BOTTOM:
                    return { top: elementData.top + elementData.height, left: elementData.left + elementData.width/2 - popupData.width/2 };
                case LEFT :
                    return { top: elementData.top + ( elementData.height/2 - popupData.height/2 ), left: elementData.left - popupData.width };
                default:
                    return { top: elementData.top + ( elementData.height/2 - popupData.height/2 ), left: elementData.left + elementData.width };
            }
        }

        function updateArrowPosition(){
            var $arrow = $popover.find('.arrow'),
                HALF = '50%';
            $arrow.css( placement === TOP || placement === BOTTOM ? LEFT : TOP, HALF);
        }

        if ( popoverData && elementData ) {
            popoverData.width  = $popover.outerWidth();
            popoverData.height = $popover.outerHeight();

            elementData.width  = $element.outerWidth();
            elementData.height = $element.outerHeight();

            $popover.css(
                getPositionData(
                    elementData,
                    popoverData
                )
            );

            updateArrowPosition();
        }
    }

    /**
     * The Popover Binding handler
     * Required:
     *          template (as string) = this is a single template string that can be passed in just like the include binding handler
     *
     *          OR
     *
     *          data (viewModel) = This will be the view model that assists in populating the template
                         Can define a "onPopoverHidden" function which is called when the popover gets hidden
     *          name (template string) = This is the template that will be placed into the popover container
     *
     *          OR
     *
     *          data (viewModel)
     *          templateAsString - html that will be used as the template          
     *
     * Options:
     *          placement (string) = accepts top, bottom, left, right, auto; default - 'right'
     *          title (string, function) = sets the title of the popover in the header; default - ''
     *          singleInstance = true or false. closes other instances of popover when opened,
     *          keepPopoverInDom - If true the popover DOM elements get hidden instead of removed from the DOM.  When the
     *                             elements are removed from the DOM, the viewModel binding breaks down and updates to
     *                             information in the viewModel are not displayed.  If you plan on changing the viewmodel
     *                             contents after first popover shown - then set this to true.
     *          updatePosition - Observable - if this value mutates, the popup position is reevaluated and the positioning
     *                           is reset based on the contents of the view.
     *          triggerOpen - if mutated to true the popup will be shown.  If false popover will be closed.
     *          triggerApply - if changed to true the popup will be hidden - popoverApply event will be dispatched
     *          showingBackButton - observable, when true the displays a back button before the title
     *          backAction - function to be called when the back button is clicked
     *          hideTitle - if true, the popover's title section will be hidden; Default: false
     *          trigger - How popover is triggered - click | hover | focus | manual. You may pass multiple triggers;
     *                    separate them with a space. `manual` cannot be combined with any other trigger.; Default: 'manual'
     *          customTemplate (html string) - allows for providing a custom tooltip template. See Bootstrap's 'template' option
     *                                         explanation in the popover documentation
     *          clickOffToClose (boolean) - True if the popover should close when the user clicks off. Defaults to false
     *
     *
     * @Example:
     *  Basic:
     *  <div data-bind="popover: {
     *              name: template,
     *              data: viewModel
     *  }">
     *
     *  <div data-bind = "popover: 'template/someTemplate' >
     *
     *  Complex:
     *  <div data-bind= "popover: {
     *              name: template,
     *              data: viewModel,
     *              placement: 'bottom',
     *              title: 'Some Title',
     *              singleInstance: true
     *              }">
     *
     * @type {{init: init}}
     */
    ko.bindingHandlers.popover = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var $element = $(element);
            var delay,
                placement,
                title,
                singleInstance,
                hideTitle,
                trigger,
                customTemplate,

                subscribeToUpdate,
                updateSubscription,
                subscribeToOpen,

                keepPopoverInDom,

                showingBackButton,
                backAction,

                container,

                openOnFocus,

                popoverOptions,
                settings = ko.unwrap(valueAccessor());

            /*
                Configure Popover settings
             */
            if (settings) {

                //set toggle to click, could possibly change this in the future to user defined
                delay = 0;

                //set the default placement to right unless specified in the binding handler
                placement = settings.placement || 'right';

                //check for and set title of popover
                title = settings.title || '';

                //allows only one popover to be displayed at a time
                singleInstance = settings.singleInstance || true;

                // if true the popover will be repositioned based on placement when this observable changes.
                // This is necessary when the popover contents change the size of the popover asynchronously
                subscribeToUpdate = _.has( settings, UPDATE_POSITION);

                // register listeners to trigger the popover dynamically
                subscribeToOpen  =  _.has( settings, IS_OPEN );

                // If true - the popover dom is hidden instead of removed when closed so that the bindings are maintained.
                // If not the dataModel bindings break when the popover dom element is removed.  This is normally inconsequential
                // because ko maintains the click handler - but the bound observables no longer update the popover view after
                // the close button has been clicked.
                keepPopoverInDom = settings.keepPopoverInDom;

                showingBackButton = settings.showingBackButton || false;

                backAction = settings.backAction || _.noop;

                // used to append popover to a certain element, this can prevent the popover from being hidden by other controls
                container = settings.container || false;

                // determines if popover is to be opened on focus in addition to on click.
                openOnFocus = settings.openOnFocus || false;

                hideTitle = settings.hideTitle || false;

                trigger = settings.trigger || 'manual';

                customTemplate = settings.customTemplate || null;

            } else {
                // if all else fails alert that the binding is not setup correctly
                throw new Error("The popover binding is not correct: please use data-bind=\"popover: 'templates/sometemplate'\" or data-bind=\"{name: 'someTemplate', data: someViewModel}\"");
            }

            var popoverTitleElement = '';

            if (!hideTitle) {
                popoverTitleElement = $('<div/>', {
                    'class': POPOVER_TITLE_CLASS
                })[0];

                var popoverTitleIncludeValueAccessor = ko.observable({
                    name: TITLE_TEMPLATE_NAME,
                    data: {
                        showingBackButton: showingBackButton,
                        title: title,
                        backAction: backAction
                    }
                });

                ko.bindingHandlers.include.init.call(this, popoverTitleElement, popoverTitleIncludeValueAccessor, allBindings, viewModel, bindingContext);
                ko.bindingHandlers.include.update.call(this, popoverTitleElement, popoverTitleIncludeValueAccessor, allBindings, viewModel, bindingContext);
            }

            var popoverContentElement = $('<div/>', {
                'class': POPOVER_CONTENT_CLASS
            })[0];

            if (settings && settings.templateAsString) {
                $(popoverContentElement).append(settings.templateAsString);
                ko.applyBindingsToDescendants(settings.data || {}, popoverContentElement);
            } else {
                //Data passed to <!-- ko include: --> to render the contents of the popover, either just a string
                //    template name, or an object with a template name and data
                var includeData;
                if (typeof settings === "string") {
                    includeData = settings;
                } else {
                    includeData = {
                        name: settings.name,
                        data: settings.data
                    };
                }

                var popoverContentIncludeValueAccessor = ko.observable({
                    name: CONTENT_TEMPLATE_NAME,
                    data: includeData
                });

                ko.bindingHandlers.include.init.call(this, popoverContentElement, popoverContentIncludeValueAccessor, allBindings, viewModel, bindingContext);
                ko.bindingHandlers.include.update.call(this, popoverContentElement, popoverContentIncludeValueAccessor, allBindings, viewModel, bindingContext);
            }

            //check the settings and assign them to an object that will be passed into the popover
            popoverOptions = {
                content: function () { return popoverContentElement; },
                title: function () { return popoverTitleElement; },
                html: true,
                placement: placement,
                delay: delay,
                trigger: trigger,
                container: container
            };

            if (customTemplate) {
                popoverOptions.template = customTemplate;
            }

            var onClickOffEvent = function (event) {
                if ($(event.target).parents('.popover.in').length === 0 &&
                    $(event.target).parents('[data-bind*="popover:"]').length === 0 &&
                    !$(event.target).is('[data-bind*="popover:"]'))
                {
                    closePopover($element, settings);
                }
            };
            ko.utils.domData.set(element, POPOVER_CLICK_OFF_EVENT, onClickOffEvent);

            //Create the popover with specified options
            $element.popover(popoverOptions)
            .on('shown.bs.popover', function () {
                addControlListeners($element, settings);

                // if the popover will be repositioned when its content change - we want to hide it now
                // and show it when the positioning update is complete.

                if (subscribeToUpdate){

                    getPopover($element, settings).css('visibility', 'hidden');

                } else if ( keepPopoverInDom ){

                    // instead of removing the popup from the dom when the popoup closes
                    // which destroys the viewModel binding - we will just flip visibility on the popover container
                    getPopover($element, settings).css('visibility', 'visible');

                }
            });

            var eventString = openOnFocus ? 'click.popover, focus.popover' : 'click.popover';

            $element.on(eventString, function (event) {
                event.preventDefault();

                if ( singleInstance ){
                    var $otherPopoverTriggers = $('[data-bind*="popover:"]').not($(this));

                    if ( keepPopoverInDom ){
                        $otherPopoverTriggers.next().css('visibility', 'hidden');
                    } else {
                        $otherPopoverTriggers.popover('hide');
                    }

                }
                //If we're keeping the popover in the DOM, only use .popover('show') the first time
                var $existingPopover = getPopover($element, settings);
                if($existingPopover.length && keepPopoverInDom) {
                    $existingPopover.css('visibility', 'visible');
                } else {
                    $(this).popover('show');
                }

                if ( subscribeToOpen ){
                    settings.isOpen(true);
                }
            });

            // Clean up the binding handler when the element is removed from the DOM.
            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                var $element = $(element);

                triggerOnPopoverHidden(settings);

                removeControlListeners($element, settings);
                getPopover($element, settings).remove();

                ko.utils.domData.clear(element);

                $element.remove('.popover');

                if ( subscribeToUpdate ){ updateSubscription.dispose(); }
            });

            if (subscribeToUpdate){
                updateSubscription = settings.updatePosition.subscribe(
                    _.debounce( function(){
                        repositionPopup( $element, getPopover($element, settings), placement );
                        getPopover($element, settings).css('visibility', 'visible');

                        addControlListeners($element, settings);
                    }, 200, true )
                );
            }
        },
        update: function(element, valueAccessor){
            var $element = $(element),
                settings = ko.unwrap(valueAccessor()),
                subscribeToOpen = _.has( settings, IS_OPEN );

            if ( subscribeToOpen ){
                if ( settings.isOpen() ){
                    $element.trigger('click.popover');
                } else {
                    closePopover($element, settings);
                }
            }
        }
    };
});

